import { RootState } from 'editor/src/store/index';

import { Warning } from '../types';

const EMPTY_LIST: Warning[] = [];
const getVisibleWarnings = (state: RootState) =>
  state.hostSettings.showWarningsOnlyAfterDesignRequest ? EMPTY_LIST : state.editorModules.warnings.list;

export default getVisibleWarnings;
